import { render } from "./ProductsContainer.vue?vue&type=template&id=7e880fdd"
import script from "./ProductsContainer.vue?vue&type=script&lang=js"
export * from "./ProductsContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/product/ProductsContainer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7e880fdd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7e880fdd', __exports__)) {
    api.reload('7e880fdd', __exports__)
  }
  
  module.hot.accept("./ProductsContainer.vue?vue&type=template&id=7e880fdd", () => {
    api.rerender('7e880fdd', render)
  })

}


export default __exports__